export default "__VITE_ASSET__DWNI4paz__"